export default "/images/5b404016a3f6f0109366f26d6fe7a9df.svg";